// extracted by mini-css-extract-plugin
module.exports = {"sponsoredBy":"styles_sponsoredBy__0eMhp","icon":"styles_icon__MhBil","logo":"styles_logo___DNjH"};